import React, { Component } from 'react';
import '../../css/pages/agents.css';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import iconSprite from '../../assets/icon-sprite.svg';
import { createLoan } from '../actions/p2p';
import LoanSchedule from './LoanSchedule';

class CreateProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleOnSubmit = async (e) => {
    e.preventDefault();
    const { onClose, onSubmit, history } = this.props;
    this.setState({ loading: 'Processing' }, async () => {
      try {
        const response = await createLoan(this.state);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message, {
          onClose: () => {
            history.push('/loans');
          },
        });
        onSubmit?.();
      } catch (error) {
        this.setState({ processing: false },
          () => toast.error(error.response?.data?.message || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.'));
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const {
      loan_amount, interest_rate, duration, tenor_period, loading,
    } = this.state;

    return (
      <>
        <SideNav />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav />
            <section className="body-main__content">
              <div className="pageTitle pageTitle--main">
                <a href="/loans" className="btn-with-navig d-inline-flex justify-content-center align-items-center d-lg-none">
                  <div className="icon">
                    <svg width="20" height="20">
                      <use xlinkHref={`${iconSprite}#go-back`}></use>
                    </svg>
                  </div>
                  <p>Back to Loans</p>
                </a>
              </div>
              <main className="create-agent__main">
                <div className="create-agent__main--container">
                  <div className="create-agent__text">
                    <h3 className="create-agent__text--header">
                      Create Loan Product.
                    </h3>
                    <p className="create-agent__text--subheader">
                      Enter the details of the loan.
                    </p>
                  </div>
                  <div className="default-card create-agent__form">
                    <div className="create-agent__form-title">
                      <p>Add Loan Product</p>
                    </div>
                    <form action="" onSubmit={this.handleOnSubmit}>
                      <div>
                        <div className="form-group">
                          <label htmlFor="phone" className="form-label">Phone Number</label>
                          <input
                            type="number"
                            className="form-control"
                            id="phone_number"
                            name="phone_number"
                            onChange={this.handleOnChange}
                            required />
                        </div>
                        <div className="form-group">
                          <label htmlFor="phone" className="form-label">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            onChange={this.handleOnChange}
                            required />
                        </div>
                        <div className="form-group">
                          <label htmlFor="productss" className="form-label">Product Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="products"
                            name="products"
                            onChange={this.handleOnChange}
                            required />
                        </div>
                        <div className="form-group">
                          <label htmlFor="loan_amount" className="form-label">Loan Amount</label>
                          <input
                            type="number"
                            className="form-control"
                            id="loan_amount"
                            name="loan_amount"
                            onChange={this.handleOnChange}
                            required />
                        </div>
                        <div className="form-group">
                          <label htmlFor="interest_rate" className="form-label">Interest Rate</label>
                          <input
                            type="number"
                            step="0.01"
                            presicion={2}
                            className="form-control"
                            id="interest_rate"
                            name="interest_rate"
                            min="1.5"
                            onChange={this.handleOnChange}
                            required />
                        </div>
                        <div className="form-group">
                          <label htmlFor="interest_method" className="form-label">Interest Method</label>
                          <div className="input-with-icon">
                            <select
                              className="form-control"
                              id="interest_method"
                              name="interest_method"
                              onChange={this.handleOnChange}>
                              <option selected value="fixed">Fixed Interest</option>
                              <option value="reducing balance">Reducing balance</option>
                              <option value="interest only">Interest only</option>
                            </select>
                            <span className="input-icon">
                              <svg width="24" height="24">
                                <use xlinkHref={`${iconSprite}#dropdown`}></use>
                              </svg>
                            </span>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="tenor_period" className="form-label">Tenor Period</label>
                          <div className="input-with-icon">
                            <select
                              className="form-control"
                              id="tenor_period"
                              name="tenor_period"
                              onChange={this.handleOnChange}>
                              <option disabled selected>Tenor Period</option>
                              <option value="days">Days</option>
                              <option value="months">Months</option>
                            </select>
                            <span className="input-icon">
                              <svg width="24" height="24">
                                <use xlinkHref={`${iconSprite}#dropdown`}></use>
                              </svg>
                            </span>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="duration" className="form-label">Tenor Period</label>
                          <input
                            type="number"
                            className="form-control"
                            id="duration"
                            name="duration"
                            min="0"
                            onChange={this.handleOnChange}
                            required />
                        </div>
                        <div className="form-group">
                          <label htmlFor="duration" className="form-label">First Repayment Date (Optional)</label>
                          <input
                            type="date"
                            className="form-control"
                            name="due_date"
                            onChange={this.handleOnChange} />
                        </div>
                        <div className="form-group">
                          <label htmlFor="require_guarantor" className="form-label">Do you want a guarantor for this loan</label>
                          <div className="Row">
                            <div className="col-md-6">
                              <label className="card-check card-check__radio">
                                <input
                                  className="card-check__option"
                                  type="radio"
                                  name="require_guarantor"
                                  value=""
                                  onChange={() => this.setState({ require_guarantor: true })} />
                                <div className="card-check__value">
                                  <span className="card-check__checkmark"></span>
                                  <p className="card-check__value-text">Yes</p>
                                </div>
                              </label>
                            </div>
                            <div className="col-md-6">
                              <label className="card-check card-check__radio">
                                <input
                                  className="card-check__option"
                                  type="radio"
                                  name="require_guarantor"
                                  value="0"
                                  onChange={() => this.setState({ require_guarantor: false })} />
                                <div className="card-check__value">
                                  <span className="card-check__checkmark"></span>
                                  <p className="card-check__value-text">No</p>
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {loan_amount && interest_rate && duration && tenor_period
                        && (
                          <LoanSchedule
                            loan_amount={loan_amount}
                            interest_rate={interest_rate}
                            duration={duration}
                            tenor_period={tenor_period} />
                        )} */}
                      <div className="modal-footer">
                        <button
                          type="submit"
                          disabled={loading}
                          className="btn btn-primary">
                          {loading || 'Create Loan'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </main>
            </section>
          </div>
        </main>
      </>
    );
  }
}

export default CreateProducts;
